import {AGREEMENT_STATUS_UNAGREEMENT} from '@/util';

const getters = {
    check: (state) => {
        return !!state.user;
    },
    name: (state) => {
        return state.user ? state.user.name : ''
    },
    user_code: (state) => {
        return state.user ? state.user.user_code : ''
    },
    company_code: (state) => {
        return state.user ? state.user.company_code : ''
    },
    company_name: (state) => {
        return state.user ? state.user.company_name : ''
    },
    agreement_web_report: (state) => {
        return state.user ? state.user.agreement_web_report : AGREEMENT_STATUS_UNAGREEMENT
    },
    agreement_demand_report: (state) => {
        return state.user ? state.user.agreement_demand_report : AGREEMENT_STATUS_UNAGREEMENT
    },
    token: (state) => {
        return state.token ? state.token : ''
    },
};

export default getters;